<template>
  <div>
      <validation-provider v-slot="{ errors }" class="mb-2" :rules="required ? 'required' : ''" :name="label">
          <v-file-input
                  class="file-base"
                  ref="fileupload"
                  :error-messages="errors"
                  v-model="file"
                  @change="changeFiles"
                  accept="image/*, video/*"
                  :placeholder="placeholder"
                  :label="label"
                  prepend-icon="mdi-cloud-upload"
                  clearable
          >
              <template  v-slot:label>
                  {{ label }}<span v-if="required" style="color: red;margin-left: 2px;">*</span>
              </template>
          </v-file-input>
      </validation-provider>
  </div>
</template>
<script>
import moment from 'moment';
import { MAX_SIZE_FILE_UPLOAD } from '@/modules/teacher-support/helpers';
import { COMMON_PROPS_FILE } from '@/modules/teacher-support/constaint/file';
import TicketRepository from '@/services/TicketRespository';

export default {
  name: 'BaseFile',
  props: { ...COMMON_PROPS_FILE },
  data() {
    return {
      image: '',
      file: undefined,
    };
  },
  watch: {
    image(value) {
      this.$emit('input', value);
    },
    file(value) {
      if (!value) {
        this.image = '';
      }
      this.$emit('input', this.image);
    },
  },
  created() {
    this.image = this.value;
  },
  methods: {
    async changeFiles() {
      if (this.file) {
        let checkError = false;
        if (this.file.size > MAX_SIZE_FILE_UPLOAD) {
          checkError = true;
          this.file = null;
        }
        if (checkError) {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Không thể tải file lớn hơn 5 MB !',
          });
          return;
        }
        this.getBase64(this.file).then((data) => {
          console.log(data, 'data');
          this.uploadFile(data);
        });
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(
          reader.result
            .replace('data:', '')
            .replace(/^.+,/, ''),
        );
        reader.onerror = (error) => reject(error);
      });
    },
    async uploadFile(data) {
      const currentDate = moment().format('DD-MM-YYYY-HH-mm-ss');
      const fileName = this.file.name.trim()?.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/đ/g, 'd')
        .replace(/Đ/g, 'D')
        .replace(/ /g, '_');
      const file = {
        name: `${currentDate}_${fileName}`,
        content: data,
        size: this.file.size,
        type: this.file.type,
      };

      this.loading = this.$loading.show();
      const response = await TicketRepository.uploadImage(file);
      this.loading.hide();
      if (response.success) {
        this.$swal({
          type: 'success',
          icon: 'success',
          text: 'Tải file lên thành công',
        });
        this.image = response.data.url;
      } else {
        this.$swal({
          type: 'error',
          icon: 'error',
          text: 'Tải file lên thất bại',
        });
        this.image = '';
        this.file = undefined;
      }
    },
  },

};
</script>
<style lang="scss">
.file-base .v-file-input__text--placeholder {
  font-size: 13px !important;
  font-style: italic !important;
}
</style>
